import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhomSection() {
  return <section className="py-24 bg-slate-950" data-id="element-78">
      <div className="container mx-auto px-4" data-id="element-79">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-80">
          {/* For You */}
          <div className="bg-slate-900/50 rounded-2xl p-8 border border-green-900/30" data-id="element-81">
            <h3 className="text-3xl font-black text-white mb-8 uppercase flex items-center gap-3" data-id="element-82">
              <span className="text-green-500" data-id="element-83">Esto es para vos</span> si:
            </h3>
            <ul className="space-y-6" data-id="element-84">
              {['Odias perder', 'Querés respeto dentro del juego', 'Te tomás Free Fire en serio', 'Querés ventaja real', 'Querés dejar de ser promedio'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-85">
                  <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-86" />
                  <span className="text-lg text-slate-200 font-medium" data-id="element-87">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-slate-900/50 rounded-2xl p-8 border border-red-900/30 opacity-75 hover:opacity-100 transition-opacity" data-id="element-88">
            <h3 className="text-3xl font-black text-slate-400 mb-8 uppercase flex items-center gap-3" data-id="element-89">
              <span className="text-red-500" data-id="element-90">No es para vos</span> si:
            </h3>
            <ul className="space-y-6" data-id="element-91">
              {['Buscás hacks mágicos', 'No querés practicar', 'Solo jugás para pasar el rato'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-92">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-93" />
                  <span className="text-lg text-slate-400 font-medium" data-id="element-94">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}